module.exports = new __parcel__URL__("logo.4474c526.svg").toString();